import React from "react";
import { useTranslation } from "react-i18next";
import NavigationStylesExport from "../../NavigationStyles";
import { NavigationLink } from "../../NavigationStyles";
import UserAvatar from "../UserAvatar";

/**
 * Mobile Buttons Component (hamburger menu and user avatar)
 */
export const MobileButtons = ({
  isMobileMenuOpen,
  toggleMobileMenu,
  username,
  userImageUrl,
  avatarInitial,
}) => {
  const { HEADER_STYLES } = NavigationStylesExport;
  const { t } = useTranslation("common");

  return (
    <div className={HEADER_STYLES.mobileContainer}>
      {/* Mobile Login or User Avatar */}
      {userImageUrl || username ? (
        <UserAvatar
          username={username}
          userImageUrl={userImageUrl}
          avatarInitial={avatarInitial}
          size="small"
        />
      ) : (
        <NavigationLink to="/signin" variant="mobile-auth">
          {t("navigation.signIn")}
        </NavigationLink>
      )}
      {/* Mobile menu button */}
      <button
        onClick={toggleMobileMenu}
        className={HEADER_STYLES.mobileMenuButton}
        aria-label="Toggle mobile menu"
      >
        <svg
          className="h-6 w-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isMobileMenuOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>
    </div>
  );
};
